export const portfolio = [
    {
        id: 1,
        img: "./assets/nutri_glow.png",
        link: "https://nutri-glow.netlify.app/",
        github: "https://github.com/codewurld/NutriGlow-Pregnancy-Health-App"
    },
    {
        id: 2,
        img: "./assets/flexercise_guy.png",
        link: "https://schoolofcode.github.io/w15_collaborative-react-project-fitness-app/",

    }
]

export const portfolioList = [
    {
        id: 1,
        title: "Web Social Media App",
        img: "./assets/nutri_glow.png",
        description: "Web app built for a NHS affiliated client to guide people on a motherhood journey towards a healthy balanced diet and lifestyle.",
        tools: "HTML, Sass, React, Firebase.",
        link: "https://nutri-glow.netlify.app/",
        github: "https://github.com/codewurld/NutriGlow-Pregnancy-Health-App"
    },
    {
        id: 2,
        title: "Eye on The Money",
        img: "./assets/eye-spy.png",
        description: "Simple expense management full stack app built to learn and improve full stack skills.",
        tools: "React, MongoDB, Express, NodeJs, CSS.",
        link: "https://eye-on-the-money.herokuapp.com/",
        github: "https://github.com/codewurld/eye-on-the-money-app"
    },

    {
        id: 3,
        title: "NOMADS. Test Store (MVP)",
        img: "./assets/nomads_test_2.png",
        description: "MVP demo E-commerce web app built for a fashion lifestyle brand.",
        tools: "React, MaterialUI, CommerceJS, Stripe API.",
        link: "https://nomads-test-store.netlify.app/",
        github: "https://github.com/codewurld/e-commerce-app"
    },

    // {
    //     id: 4,
    //     title: "Flexercise Exercise App",
    //     img: "./assets/flexercise_guy.png",
    //     description: "Bite-sized exercise app created to help time starved young professionals to keep healthy.",
    //     tools: "HTML, CSS, React, PWA (available as mobile app).",
    //     link: "https://schoolofcode.github.io/w15_collaborative-react-project-fitness-app/"
    // },


    // {
    //     id: 5,
    //     title: "Web Design",
    //     img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
    //     link: "https://schoolofcode.github.io/w15_collaborative-react-project-fitness-app/"
    // },
    // {
    //     id: 6,
    //     title: "Web Banking App",
    //     img: "https://cdn.dribbble.com/users/6384483/screenshots/15468426/media/ce9479fa1f8dba3a4a49840d76e55e31.png?compress=1&resize=1200x900",
    //     link: "https://schoolofcode.github.io/w15_collaborative-react-project-fitness-app/"
    // },
];
